"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashList = void 0;
var hashList = [{
  title: 'Our Brand',
  hash: 'statements'
}, {
  title: 'Logos',
  hash: 'logos'
}, {
  title: 'Typography',
  hash: 'typography'
}, {
  title: 'Palette',
  hash: 'colors'
}, {
  title: 'Templates',
  hash: 'videos'
}, {
  title: 'Style Guide',
  hash: 'style-guides'
}];
exports.hashList = hashList;